import { Box, IconButton, Stack, useTheme, Link as MuiLink, Button } from "@mui/material"
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { Link, useLocation } from "react-router-dom";
import { RoutePaths } from "../../../routes";


export const MenuMobile = ({ open, setOpen }) => {
    return (
        <>
            <Stack alignItems='flex-end' sx={{
                width: '100%',
            }}>
                <IconButton onClick={() => setOpen(prev => !prev)}>
                    {open ? <CloseIcon fontSize="large" /> : <MenuIcon fontSize="large" />}
                </IconButton>
            </Stack>
        </>
    )
}

export const MobMenuList = ({ links }) => {
    const theme = useTheme()
    const location = useLocation()
    return (
        <>
            <Stack alignItems='center' justifyContent='center' sx={{ mt: 1, mb: 2 }}>
                {links.map((link, index) => (
                    <MuiLink
                        component={Link}
                        sx={{
                            ...theme.typography.menu,
                            mt: 1,
                            mb: 1,
                            pl: '25px',
                            pr: '25px',
                            color: location.pathname.indexOf(link.url) >= 0 ? 'red.500' : 'blue.400',
                        }}
                        key={index}
                        to={link.url}
                        onClick={link.handleClick ? link.handleClick : () => null}
                        underline="hover"
                    >
                        {link.label}
                    </MuiLink>
                ))}

                <Box sx={{ mt: 3 }}>
                    <Button component={MuiLink} href={RoutePaths.LK} target="_blank" variant="contained">Личный кабинет</Button>
                </Box>
            </Stack>
        </>
    )
}
